<template>
  <div id="entidades-toolbar-entidades">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Entidades
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
